import BaseComponent from '../base-component/base-component'
import { checkEnterKey } from '../../utils/utils'
import List from './list'

class ListBtn extends BaseComponent {
  connectedCallback(): void {
    this.addEventListener('keydown', this.handleKeyDown)
    this.addEventListener('click', this.handleButtonClick)
  }

  disconnectedCallback(): void {
    this.removeEventListener('keydown', this.handleKeyDown)
    this.removeEventListener('click', this.handleButtonClick)
  }

  handleButtonClick = (): void => {
    this.update()
  }

  handleKeyDown = (event: KeyboardEvent): void => {
    const isEnterKey = checkEnterKey(event.key || event.keyCode)

    if (isEnterKey) {
      event.preventDefault()

      this.update()
    }
  }

  update(): void {
    const list = this.closest<List>('list-component')

    if (!list) {
      return
    }

    if (this.dataset.trigger === 'collapse') {
      list.collapse()
    } else {
      list.expand()
    }
  }
}

export default ListBtn
